export default __webpack_public_path__ + "static/about-us-dbaa05345fe559aaa00fd2bf07043ae4.webp";